











































































import Vue from "vue";
import iwAddressAutocomplete from "@/encoding/pages/questions/address/AddressAutocomplete.vue";
import iwAddressStreet from "@/encoding/pages/questions/address/AddressStreet.vue";
import iwAddressNumber from "@/encoding/pages/questions/address/AddressNumber.vue";
import iwAddressPostalcode from "@/encoding/pages/questions/address/AddressPostalcode.vue";
import iwAddressLocality from "@/encoding/pages/questions/address/AddressLocality.vue";
import iwAddressCountry from "@/encoding/pages/questions/address/AddressCountry.vue";
import iwAddressPreviewMap from "@/encoding/pages/questions/address/AddressPreviewMap.vue";
import iwAddressIsPublic from "@/encoding/pages/questions/address/AddressIsPublic.vue";
import iwAddressFloor from "@/encoding/pages/questions/address/AddressFloor.vue";
import iwAddressBox from "@/encoding/pages/questions/address/AddressBox.vue";
import iwInputText from "@/encoding/components/buildingBlocks/InputText.vue";
import iwNextPreviousButton from "@/encoding/components/NextPreviousButton.vue";


import mbxGeocoding from "@mapbox/mapbox-sdk/services/geocoding";
import { Trans } from "@/shared/scripts/helpers/translation/translation";

// Utils
import iwInlineQuestions from "@/encoding/components/layout/InlineQuestions.vue";

// Interfaces
import { Coordinates } from "@/shared/interfaces/Location.interface";
import { mapActions, mapGetters } from "vuex";
import { pushPageViewEvent } from "@/shared/store/modules/gtm/datalayer";
import { updateClassified } from "@/shared/scripts/ValidateData";

export default Vue.extend({
    components: {
        iwInlineQuestions: iwInlineQuestions,
        iwAddressAutocomplete: iwAddressAutocomplete,
        iwAddressStreet: iwAddressStreet,
        iwAddressNumber: iwAddressNumber,
        iwAddressPostalcode: iwAddressPostalcode,
        iwAddressLocality: iwAddressLocality,
        iwAddressCountry: iwAddressCountry,
        iwAddressPreviewMap: iwAddressPreviewMap,
        iwAddressIsPublic: iwAddressIsPublic,
        iwAddressFloor: iwAddressFloor,
        iwAddressBox: iwAddressBox,
        iwInputText: iwInputText,
        iwNextPreviousButton: iwNextPreviousButton
    },
    data: function() {
        return {
            isAddressDetailVisible: false,
            isMapPreviewVisible: false,
            isMobile: true as boolean,
            previewMapCoordinates: null as unknown as Coordinates,
            pathInStoreMapCoordinates: "urlMapbox.coordinates",
            isButtonDisabled: false as boolean,
        };
    },
    computed: {
        ...mapGetters({
            isReadonlyField: "FormModule/isReadonlyField",
            editNotAllowed: "FormModule/editNotAllowed",
            getFirstPublicationDate: "FormModule/getFirstPublicationDate"
        }),
        editExpirationDate: function(): string | null {
            return this.$store.getters["FormModule/editExpirationDate"];
        },
        canHaveFloor: function(): boolean {
            return ["APARTMENT", "OFFICE", "INDUSTRY", "COMMERCIAL", "GARAGE"].indexOf(this.getPropertyType()) !== - 1;
        },
        street: function(): string | null {
            return this.$store.getters["FormModule/getValue"]("property.location.address.street");
        },
        locality: function(): string | null {
            return this.$store.getters["FormModule/getValue"]("property.location.address.locality");
        },
        number: function(): string | null {
            return this.$store.getters["FormModule/getValue"]("property.location.address.number");
        },
        floor: function(): string | null {
            return this.$store.getters["FormModule/getValue"]("property.location.address.floor");
        },
        postalCode: function(): string | null {
            return this.$store.getters["FormModule/getValue"]("property.location.address.postalCode");
        },
        country: function(): string | null {
            return this.$store.getters["FormModule/getValue"]("property.location.address.country");
        },
        completeAddress: function(): string {

            let address = "";

            if (this.street) {
                address += this.street + ", ";
            }

            if (this.number) {
                address += this.number + ", ";
            }

            if (this.postalCode) {
                address += this.postalCode + ", ";
            }

            if (this.locality) {
                address += this.locality + ", ";
            }

            if (this.country) {
                address += this.country;
            }

            return address;
        },
        isAddressDetailsVisible: function(): boolean {
            return !!this.completeAddress;
        }
    },

    mounted: function() {
        pushPageViewEvent("classified_deposit_step2_adress");
        this.$responsive.registerMediaQuery("from-medium", () => {
            this.isMobile = false;
        }, () => {
            this.isMobile = true;
        });

        if (this.completeAddress) {
            this.isAddressDetailVisible = true;
        }
        const coordinatesUI = this.$store.getters["FormModule/getValueUI"](this.pathInStoreMapCoordinates);
        if (coordinatesUI) {
            this.displayPreviewMap(coordinatesUI);
        }
    },
    methods: {
        ...mapActions({
            validateAndGoToNextStep: "FormModule/validateAndGoToNextStep",
            goToPreviousStep: "StepsWizard/previous",
            goToNextStep: "StepsWizard/next"
        }),
        displayPreviewMap: function (coordinates: Coordinates):void {
            this.isMapPreviewVisible = true;
            this.previewMapCoordinates = coordinates;
        },
        clickNext: function(){

            this.isButtonDisabled = true;
            updateClassified(() => {
                Vue.nextTick(() => {
                    const inputsError = document.getElementsByClassName("input--error") as HTMLCollectionOf<HTMLElement>;
                    if (inputsError.length > 0) {
                        inputsError[0].focus();
                        window.scrollTo(0, 0);
                    }
                    this.goToNextStep();

                    this.isButtonDisabled = false;
                });
            });
        },
        clickPrevious: function(){

            //Work without it ?
            this.goToPreviousStep();
            // this.routeToPage("step-property-type");
        },
        updatePreviewMap: function () {
            if (this.completeAddress) {
                const mapBoxApiToken = process.env.VUE_APP_IMMOWEB_MAPBOX_API_TOKEN;

                if (mapBoxApiToken) {
                    const geocodingClient = mbxGeocoding({
                        accessToken: mapBoxApiToken
                    });

                    return geocodingClient.forwardGeocode({
                        autocomplete: false,
                        mode: "mapbox.places",
                        query: this.completeAddress,
                        types: ["address", "poi"],
                        language: [Trans.currentLocale]
                    })
                        .send()
                        .then((response) => {
                            if (response.statusCode === 200) {
                                const features = response.body.features;

                                if (features && features[0]) {

                                    const featureCenter = features[0].center;

                                    if (featureCenter) {

                                        const featureCoordinates = {
                                            lat: featureCenter[1],
                                            lng: featureCenter[0]
                                        };

                                        this.previewMapCoordinates = featureCoordinates;
                                        this.$store.commit("FormModule/addValueUI", {path: this.pathInStoreMapCoordinates, value: featureCoordinates});
                                    }
                                }
                            }

                        });
                }
            }
        }
    }
});

